<script setup lang="ts">
interface Props {
  label: string;
  loading?: boolean;   // Optional: defaults to false
  btnClass?: string;   // Optional: allow 'btn-warning', 'btn-primary', etc.
  type?: 'button' | 'submit' | 'reset';
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  type: 'button',
  btnClass: 'btn-warning'
});

const emit = defineEmits<{
  (e: 'click'): void
}>();

const handleClick = () => {
  // Only emit click if we aren't currently loading
  if (!props.loading) {
    emit('click');
  }
};
</script>

<template>
  <button
      :type="type || 'button'"
      class="btn"
      :class="btnClass"
      :disabled="loading"
      @click="handleClick"
  >
    <template v-if="loading">
      <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
      ></span>
    </template>

    <span v-else>
      {{ label }}
    </span>
  </button>
</template>

<style scoped>
button {
  min-width: 150px;
}
</style>